import store from './store';
import * as types from './constants';
import { API_URL } from '../config/apiURL';
import { requestApi } from '../config/api';

/*
 *   --- Function to LogIN-OUT, SignIn ---
 */

export function login_user(data) {
   return {
      type: types.LOGIN,
      data,
      url: API_URL + '/users/login',
   };
}

export function logOut() {
   return {
      type: types.LOGOUT,
   };
}

export function signin_user(datos) {
   return {
      type: types.SIGNIN,
      datos,
      url: API_URL + '/users/signin',
   };
}

/*
 *   --- Function to get all categories ---
 */

export function get_categories() {
   return {
      type: types.GET_CATEGORIES,
      url: API_URL + '/categories/get',
   };
}

/*
 *   --- Function to get catalogo ---
 */

export function get_all_catalogo() {
   return {
      type: types.OBTENER_CATALOGO,
      url: API_URL + '/catalogo/getAll',
   };
}

export function get_catalogo(categoria) {
   return {
      type: types.GET_PRODUCTS,
      data: {
         id_categoria: categoria.id_categoria,
         categoria: categoria,
         limit: categoria.limit,
      },
      url: API_URL + '/catalogo/get',
   };
}

export function getHomeProducts() {
   return {
      type: types.GET_HOME_PRODUCTS,
      data: {},
      url: API_URL + '/catalogo/home-products',
   };
}

export function get_catalogo_busqueda(busqueda) {
   return {
      type: types.OBTENER_CATALOGO_BUSQUEDA,
      datos: { busqueda: busqueda },
      url: API_URL + '/catalogo/buscar',
   };
}

/*
 *   --- Function to get top selling products ---
 */

export async function getTopSellingProducts() {
   const request = await requestApi(
      API_URL + '/catalogo/top-selling',
      'GET',
      [],
      null
   );
   return request.data;
}

/*
 *   --- Function to filter catalogo ---
 */

export function filtrar_catalogo(precio_max, precio_min) {
   const catalogo = store.getState().catalogo;

   return {
      type: types.FILTER_PRODUCTS,
      catalogo_filtrado: catalogo.filter(producto => {
         return producto.Precio <= precio_max && producto.Precio >= precio_min;
      }),
   };
}

export function busqueda_catalogo(busqueda) {
   const catalogo = store.getState().catalogo;

   return {
      type: types.BUSQUEDA_CATALOGO,
      catalogo_filtrado: catalogo.filter(producto => {
         return (
            producto.Producto.toLowerCase().indexOf(busqueda.toLowerCase()) !==
            -1
         );
      }),
   };
}

/*
 *   --- Function add cart items ---
 */

export function add_carrito(producto) {
   const carrito = store.getState().carrito;
   const exist = carrito.find(item => {
      return item.id_producto === producto.id_producto;
   });

   if (exist) {
      exist.cantidad = exist.cantidad + 1;
   } else {
      Object.assign(producto, { cantidad: 1 });
      carrito.push(producto);
   }
   let subtotal = 0;
   carrito.forEach(producto => {
      // Calcula el subtotal del carrito
      subtotal = subtotal + producto.Precio * producto.cantidad;
      // Asigna el importe
      Object.assign(producto, { importe: producto.Precio * producto.cantidad });
   });
   return {
      type: types.AGREGAR_CARRITO,
      carrito: carrito,
      producto: producto,
      subtotal: subtotal,
   };
}

export function upd_carrito(cart, product) {
   let subtotal = 0;
   cart.forEach(producto => {
      // Calcula el subtotal del carrito
      subtotal = subtotal + producto.Precio * producto.cantidad;
      // Asigna el importe
      Object.assign(producto, { importe: producto.Precio * producto.cantidad });
   });
   return {
      type: types.AGREGAR_CARRITO,
      carrito: cart,
      producto: product,
      subtotal: subtotal,
   };
}

export function removeProd(id_producto) {
   let carrito = store.getState().carrito;
   carrito = carrito.filter(item => {
      return item.id_producto !== id_producto;
   });
   let producto = carrito[carrito.length - 1];
   if (!producto) {
      producto = { id_producto: 0 };
   }
   let subtotal = 0;
   carrito.forEach(producto => {
      // Calcula el subtotal del carrito
      subtotal = subtotal + producto.Precio * producto.cantidad;
   });
   return {
      type: types.QUITAR_CARRITO,
      carrito: carrito,
      producto: producto,
      subtotal: subtotal,
   };
}

export function get_clientesSucursales() {
   return {
      type: types.OBTENER_DIRECCIONES,
      url: API_URL + '/users/obtener_direcciones',
   };
}

export function checkPrices(data) {
   return {
      type: types.CHECK_PRICES,
      url: API_URL + '/carrito/verificar',
      data,
   };
}

export function checkOut(data, comment) {
   return {
      type: types.CHECKOUT,
      url: API_URL + '/carrito/finalizar',
      data,
      comment,
   };
}

/*
 *   --- Function to get countries and states ---
 */

export function get_paises() {
   return {
      type: types.OBTENER_PAISES,
      url: API_URL + '/listas/obtener_paises',
   };
}

export function get_estados(id_pais) {
   return {
      type: types.OBTENER_ESTADOS,
      url: API_URL + '/listas/obtener_estados',
      id_pais: id_pais,
   };
}

/*
 *   --- Function to get Pedidos ---
 */

export function get_pedidos(fromDate, toDate) {
   return {
      type: types.OBTENER_PEDIDOS,
      url: API_URL + '/pedidos/obtener',
      data: { fromDate, toDate },
   };
}

export function getLineas_Pedidos(id_factura) {
   return {
      type: types.OBTENER_PEDIDOS_LINEAS,
      url: API_URL + '/pedidos/obtenerlineas',
      id_factura,
   };
}

/*
 *   --- Function to get Facturas ---
 */

export function get_facturas(fromDate, toDate) {
   return {
      type: types.OBTENER_PEDIDOS,
      url: API_URL + '/facturas/obtener',
      data: { fromDate, toDate },
   };
}

export function getLineas_Facturas(id_factura) {
   return {
      type: types.OBTENER_PEDIDOS_LINEAS,
      url: API_URL + '/facturas/obtenerlineas',
      id_factura,
   };
}

/*
 *   --- Function to save direction ---
 */

export function save_Direction(direction) {
   return {
      type: types.GUARDAR_DIRECCION,
      direction,
   };
}

/*
 *   --- Function to proccess payment ---
 */

export function proccess_payment(chargeRequest) {
   return {
      type: types.PROCESAR_CARGO,
      url: API_URL + '/carrito/procesar_pago',
      request: chargeRequest,
   };
}

/**
 * --- Function to save order
 */

export async function generarPedido(data) {
   const { CREAR_PEDIDO, CREAR_PEDIDO_SUCCESS, CREAR_PEDIDO_ERROR } = types;
   const request = await requestApi(
      API_URL + '/carrito/save_pedido',
      'POST',
      [CREAR_PEDIDO, CREAR_PEDIDO_SUCCESS, CREAR_PEDIDO_ERROR],
      data
   );
   return request;
}

/**
 * --- Function to send pay
 */

export async function enviarPago(data) {
   const { PROCESAR_PAGO, PROCESAR_PAGO_SUCCESS, PROCESAR_PAGO_ERROR } = types;
   const request = await requestApi(
      API_URL + '/carrito/procesar_pago',
      'POST',
      [PROCESAR_PAGO, PROCESAR_PAGO_SUCCESS, PROCESAR_PAGO_ERROR],
      data
   );
   return request;
}

/**
 * --- Function to recover password
 */

export async function recuperarContraseña(data) {
   const {
      RECUPERAR_PASSWORD,
      RECUPERAR_PASSWORD_SUCCESS,
      RECUPERAR_PASSWORD_ERROR,
   } = types;
   const request = await requestApi(
      API_URL + '/users/recuperar_password',
      'POST',
      [
         RECUPERAR_PASSWORD,
         RECUPERAR_PASSWORD_SUCCESS,
         RECUPERAR_PASSWORD_ERROR,
      ],
      data
   );
   return request;
}

/**
 * --- Funtion to validate token
 */

export async function validToken(data) {
   const { VALIDATE_TOKEN, VALIDATE_TOKEN_SUCCESS, VALIDATE_TOKEN_ERROR } =
      types;
   const request = await requestApi(
      API_URL + '/users/validartoken',
      'POST',
      [VALIDATE_TOKEN, VALIDATE_TOKEN_SUCCESS, VALIDATE_TOKEN_ERROR],
      data
   );
   return request;
}

/**
 * --- Funtion to change password
 */

export async function changePassword(data) {
   const {
      CAMBIAR_PASSWORD,
      CAMBIAR_PASSWORD_SUCCESS,
      CAMBIAR_PASSWORD_ERROR,
   } = types;
   const request = await requestApi(
      API_URL + '/users/cambiar_password',
      'POST',
      [CAMBIAR_PASSWORD, CAMBIAR_PASSWORD_SUCCESS, CAMBIAR_PASSWORD_ERROR],
      data
   );
   return request;
}



// WEBPACK FOOTER //
// ./src/redux/actions.js